import templateUrl from './review-comment-banner.component.html';

// APEX-978 - shows the owner's Request Review comment history at the top of an employee
// Fill page as a "Changes requested" thread (newest first). Self-contained: given the
// application it fetches the comments and only renders on the employee side (not owner view).
export const ReviewCommentBannerComponent = {
    templateUrl,
    controllerAs: 'vm',
    bindings: {
        application: '<',
        ownerView: '<',
        formStatus: '<', // status of THIS form (kept for callers; gating is by requestTypeId + app status)
        requestTypeId: '<', // backend RequestTypeID for THIS form (5/-2/2/3/6/7); scopes comments to this form
        hasInfo: '<' // optional; when explicitly false (e.g. Direct Deposit with no DD info) the banner is hidden
    },
    controller: ReviewCommentBannerController
};

function ReviewCommentBannerController(onboardingDocumentService) {
    'ngInject';
    const vm = this;
    vm.comments = [];

    vm.$onInit = function () {
        // Show the owner's review comments to the employee while the application is still being worked
        // (Started/Pending/Review) and until they resubmit (ApplicationSubmit clears the comments).
        // Scoped to THIS form via the comment's RequestTypeID, so it persists even after the form is
        // re-signed (which flips the form's own status off 'ReviewRequired').
        const activeStatuses = ['Started', 'Pending', 'Review', 'Paper']; // Paper: DD-only review comment (scoped by RequestTypeIds)
        if (vm.ownerView || !vm.application || !vm.application.ApplicationId
            || activeStatuses.indexOf(vm.application.ApplicationStatus) === -1) {
            return;
        }
        onboardingDocumentService.retrieveComments(vm.application.ApplicationId)
            .then(function (comments) {
                // GetComments returns newest first; keep this form's comments that carry a note.
                vm.comments = (comments || []).filter(function (c) {
                    return c && (c.Note || c.Text)
                        && (c.RequestTypeIds
                            ? c.RequestTypeIds.split(',').indexOf(String(vm.requestTypeId)) !== -1
                            : Number(c.RequestTypeID) === Number(vm.requestTypeId));
                });
            })
            .catch(function () {
                vm.comments = [];
            });
    };
}
